import whenDomReady from 'when-dom-ready';
function initialise() {
    const elements = Array.from(document.querySelectorAll('.js-testimonial-carousel'));
    elements.forEach(initialiseTabbedQuote);
}
function initialiseTabbedQuote(element) {
    const autoplayInterval = parseFloat(element.dataset.interval || '');
    const items = Array.from(element.querySelectorAll('[data-item]'));
    const quoteElements = Array.from(element.querySelectorAll('[data-quote]'));
    const triggers = Array.from(element.querySelectorAll('[data-target]'));
    let autoplayIntervalRef;
    // enableAutoplay();
    triggers.forEach(trigger => {
        trigger.addEventListener('click', event => {
            event.preventDefault();
            if (event.target instanceof HTMLElement) {
                const id = event.target.dataset.target;
                if (!id || !id.length) {
                    return;
                }
                disableAutoplay();
                setVisibleItem(id);
                setVisibleQuote(id);
            }
        });
    });
    function enableAutoplay() {
        if (element.classList.contains('is-autoplaying')) {
            return;
        }
        autoplayIntervalRef = window.setInterval(() => {
            const activeItem = getActiveItem();
            let nextItem = activeItem?.nextElementSibling;
            if (!nextItem) {
                nextItem = items[0];
            }
            const id = nextItem?.dataset.item;
            if (!id || !id.length) {
                return;
            }
            setVisibleItem(id);
            setVisibleQuote(id);
        }, autoplayInterval);
        element.classList.add('is-autoplaying');
    }
    function disableAutoplay() {
        window.clearInterval(autoplayIntervalRef);
        element.classList.remove('is-autoplaying');
    }
    function getActiveItem() {
        return element.querySelector('.is-active[data-item]');
    }
    function getItem(id) {
        return items.find(item => item.dataset.item === id);
    }
    function getQuote(id) {
        return quoteElements.find(item => item.dataset.quote === id);
    }
    function setVisibleItem(id) {
        const targetItem = getItem(id);
        if (!targetItem) {
            return;
        }
        items.forEach(item => item.classList.remove('is-active'));
        targetItem.classList.add('is-active');
    }
    function setVisibleQuote(id) {
        const targetQuote = getQuote(id);
        if (!targetQuote) {
            return;
        }
        quoteElements.forEach(item => item.classList.remove('is-active'));
        targetQuote.classList.add('is-active');
    }
    const config = {
        rootMargin: '-30px 0px',
        threshold: [0, 0.6],
    };
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {
                enableAutoplay();
            }
            else {
                disableAutoplay();
            }
        });
    }, config);
    observer.observe(element);
}
whenDomReady().then(initialise);
